export default __webpack_public_path__ + "static/media/questionmar.d8a6f977.svg";